import React from 'react';
import './App.css';
import Header from './components/Header';
import CanvasContainer from './components/CanvasContainer';
import Controls from './components/Controls';
import Notification from './components/Notification';
import { SolplaceProvider } from './context/SolplaceContext';

function App() {
  return (
    <SolplaceProvider>
      <div className="App">
        <Header />
        <CanvasContainer />
        <Controls />
        <Notification />
      </div>
    </SolplaceProvider>
  );
}

export default App;
